import { render, staticRenderFns } from "./climate.vue?vue&type=template&id=24712662"
import script from "./climate.vue?vue&type=script&lang=js"
export * from "./climate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports